import { Outlet, useLocation } from 'react-router-dom';
import { useState, useCallback, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

export default function Layout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => setMobileMenuOpen(prev => !prev), []);
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  
  // Détecter si c'est la page Chat pour supprimer le padding
  const isChatPage = location.pathname === '/chat';
  
  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 transition-colors">
      <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={closeMobileMenu} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggleMobileMenu={toggleMobileMenu} />
        <main className="flex-1 overflow-hidden flex flex-col">
          {isChatPage ? (
            // Page Chat : pas de padding, plein écran
            <Outlet />
          ) : (
            // Autres pages : avec padding et effets
            <div className="px-2 sm:px-4 lg:px-6 pb-0 pt-0 h-full flex flex-col">
              {/* Conteneur principal avec animation */}
              <div className="relative flex-1 min-h-0 flex flex-col">
                {/* Effet de particules en arrière-plan (subtil) */}
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.1),rgba(255,255,255,0))] dark:bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.05),rgba(255,255,255,0))]" />
                
                {/* Contenu principal */}
                <div className="relative z-10 h-full min-h-0">
                  <div className="h-full overflow-auto">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
